import { Stream } from 'stream';

import { EntityAccountTypeDto } from './accounts.dtos';
import { IdParamDto } from './common.dtos';

export enum AccountDocumentTypeDto {
  TrustApplication = 'TrustApplication',
  TrustAgreement = 'TrustAgreement',
  TrusteeDriverLicense = 'TrusteeDriverLicense',
  TrusteePassport = 'TrusteePassport',
  TrusteeStateIdCard = 'TrusteeStateIdCard',
  PartnershipApplication = 'PartnershipApplication',
  PartnershipAgreement = 'PartnershipAgreement',
  PartnerDriverLicense = 'PartnerDriverLicense ',
  PartnerPassport = 'PartnerPassport',
  PartnerStateIdCard = 'PartnerStateIdCard',
  CorporateApplication = 'CorporateApplication',
  CorporateArticlesOfIncorporation = 'CorporateArticlesOfIncorporation',
  CorporateOwnerDriverLicense = 'CorporateOwnerDriverLicense',
  CorporateOwnerPassport = 'CorporateOwnerPassport',
  CorporateOwnerStateIdCard = 'CorporateOwnerStateIdCard',
  LlcApplication = 'LlcApplication',
  LlcOperatingAgreement = 'LlcOperatingAgreement',
  LlcArticlesOfOrganization = 'LlcArticlesOfOrganization',
  LlcBeneficialOwnerDriverLicense = 'LlcBeneficialOwnerDriverLicense',
  LlcBeneficialOwnerPassport = 'LlcBeneficialOwnerPassport',
  LlcBeneficialOwnerStateIdCard = 'LlcBeneficialOwnerStateIdCard',
}

export interface AccountApplicationDocumentDto {
  id: string;
  type: AccountDocumentTypeDto;
  originalFilename: string;
  createdAt: string;
  updatedAt?: string;
}

export enum AccountApplicationCategoryNameDto {
  GovernmentId = 'GovernmentId',
  Application = 'Application',
  TrustAgreement = 'TrustAgreement',
  ArticlesOfIncorporation = 'ArticlesOfIncorporation',
  ArticlesOfOrganization = 'ArticlesOfOrganization',
  OperatingAgreement = 'OperatingAgreement',
  PartnershipAgreement = 'PartnershipAgreement',
}

export interface AccountApplicationCategoryDto {
  name: AccountApplicationCategoryNameDto;
  isResolved: boolean;
  requestedDocuments: AccountDocumentTypeDto[];
  totalRequestedDocuments?: number;
  uploadedDocuments: AccountApplicationDocumentDto[];
  adminNote?: string;
}

export interface AccountApplicationDto {
  id: string;
  account: {
    id: string;
    entityAccountType?: EntityAccountTypeDto;
  };
  categories: AccountApplicationCategoryDto[];
  uploadedDocuments: AccountApplicationDocumentDto[];
  createdAt: string;
  updatedAt?: string;
}

export interface BaseAccountApplicationParamsDto extends IdParamDto {
  accountId: string;
}

export interface BaseAccountApplicationDocumentParamsDto extends BaseAccountApplicationParamsDto {
  documentId: string;
}

export interface GetAccountApplicationDto {
  params: Partial<BaseAccountApplicationParamsDto>;
}

export interface UpdateAccountApplicationCategoryBodyDto {
  name: AccountApplicationCategoryNameDto;
  isResolved: boolean;
  adminNote?: string | null;
  totalRequestedDocuments?: number | null;
}

export interface UpdateAccountApplicationBodyDto {
  categories?: Array<UpdateAccountApplicationCategoryBodyDto>;
}

export interface UpdateAccountApplicationDto {
  params: BaseAccountApplicationParamsDto;
  body: UpdateAccountApplicationBodyDto;
}

export interface UploadAccountApplicationDocumentBodyDto {
  type: AccountDocumentTypeDto;
  originalFilename: string;
  file: Stream;
}

export interface UploadAccountApplicationDocumentDto {
  params: Partial<BaseAccountApplicationParamsDto>;
  body: FormData;
}

export interface DownloadAccountApplicationDocumentDto {
  params: BaseAccountApplicationDocumentParamsDto;
}

export interface DownloadAccountApplicationDocumentResponseDto {
  downloadUrl: string;
}

export interface UpdateAccountApplicationDocumentBodyDto extends UploadAccountApplicationDocumentBodyDto {}

export interface UpdateAccountApplicationDocumentDto {
  params: BaseAccountApplicationDocumentParamsDto;
  body: FormData;
}

export interface DeleteAccountApplicationDocumentDto {
  params: Partial<BaseAccountApplicationDocumentParamsDto>;
}
